import React, { useState } from 'react';
import { FadeIn, CTAButton, Section } from './Shared';
import { useCountdown } from '../hooks/useCountdown';
import { PRODUCTS } from './MetaPixel';
import { Star, ShieldCheck, ChevronDown, ChevronUp, Clock, Lock, CreditCard } from 'lucide-react';
export const Testimonials2 = () => {
  const testimonials = [{
    initials: 'LM',
    name: 'Luciana M.',
    location: 'Mendoza',
    product: 'MEGAPACK + Potenciadores',
    text: 'Después de leer los primeros tomos entendí varios errores que estaba cometiendo. Muy recomendable.',
    bg: 'bg-[#FF6B00]'
  }, {
    initials: 'JP',
    name: 'Juan P.',
    location: 'La Plata',
    product: 'MEGAPACK',
    text: 'Pensé que iba a ser otro curso más. Me sorprendió para bien.',
    bg: 'bg-[#3B82F6]'
  }, {
    initials: 'VR',
    name: 'Valeria R.',
    location: 'Santa Fe',
    product: 'MEGAPACK + Potenciadores',
    text: 'Está bueno porque no te llena de teoría. Vas aplicando mientras avanzás.',
    bg: 'bg-[#EF4444]'
  }, {
    initials: 'FA',
    name: 'Federico A.',
    location: 'Neuquén',
    product: 'MEGAPACK + Potenciadores',
    text: 'Recuperé la inversión rápido. Lo volvería a comprar sin dudar.',
    bg: 'bg-[#8B5CF6]'
  }];
  return <Section className="bg-bg-alt" data-id="element-192">
      <FadeIn className="text-center mb-8 md:mb-12" data-id="element-193">
        <h2 className="font-display font-extrabold uppercase md:text-[44px] text-txt-primary mb-3 md:mb-4 text-[32px]" data-id="element-194">
          Lo que dicen <span className="text-brandGold" data-id="element-195">los comerciantes</span>
        </h2>
        <div className="inline-flex items-center gap-2 bg-bg-card border border-line rounded-full px-4 py-2" data-id="element-196">
          <div className="flex text-brandGold" data-id="element-197">
            {[...Array(5)].map((_, j) => <Star key={j} size={14} className="fill-current" data-id="element-198" />)}
          </div>
          <span className="font-sans font-bold text-txt-primary text-sm" data-id="element-199">
            4.9/5
          </span>
          <span className="font-sans text-txt-muted text-xs md:text-sm" data-id="element-200">
            · +500 vendedores en todo el país
          </span>
        </div>
      </FadeIn>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3 md:gap-4" data-id="element-201">
        {testimonials.map((t, i) => <FadeIn key={i} delay={Math.min(i * 0.05, 0.2)} data-id="element-202">
            <div className="bg-bg-card p-4 md:p-5 rounded-[16px] border border-line h-full flex flex-col" data-id="element-203">
              <div className="flex items-center gap-2.5 mb-3" data-id="element-204">
                <div className={`w-9 h-9 ${t.bg} text-white rounded-full flex items-center justify-center font-sans font-bold text-xs shrink-0`} data-id="element-205">
                  {t.initials}
                </div>
                <div className="min-w-0" data-id="element-206">
                  <div className="flex text-brandGold mb-0.5" data-id="element-207">
                    {[...Array(5)].map((_, j) => <Star key={j} size={10} className="fill-current" data-id="element-208" />)}
                  </div>
                  <p className="font-sans font-bold text-txt-primary text-[13px] leading-tight" data-id="element-209">
                    {t.name}
                  </p>
                  <p className="text-[11px] font-sans text-txt-muted" data-id="element-210">
                    📍 {t.location}
                  </p>
                </div>
              </div>
              <p className="text-txt-body font-sans text-[13px] md:text-[14px] leading-[1.5] italic mb-2.5" data-id="element-211">
                "{t.text}"
              </p>
              <p className="font-sans font-bold uppercase tracking-[1px] text-[9px] md:text-[10px] text-brandGold mt-auto" data-id="element-212">
                {t.product}
              </p>
            </div>
          </FadeIn>)}
      </div>
    </Section>;
};
export const Guarantee = () => {
  return <Section className="bg-bg-base" data-id="element-213">
      <FadeIn className="max-w-3xl mx-auto text-center" data-id="element-214">
        <div className="bg-bg-card border border-[rgba(34,197,94,0.2)] rounded-[20px] p-6 md:p-10 relative overflow-hidden" data-id="element-215">
          <div className="absolute inset-0 bg-gradient-to-b from-[rgba(245,166,35,0.05)] to-transparent pointer-events-none" data-id="element-216"></div>
          <ShieldCheck size={70} className="mx-auto text-success mb-5 md:mb-6 relative z-10" data-id="element-217" />
          <h2 className="font-display font-extrabold uppercase text-[26px] md:text-[44px] leading-[1.1] text-txt-primary mb-6 md:mb-8 relative z-10" data-id="element-218">
            🛡️ GARANTÍA 15 DÍAS — SIN PREGUNTAS
          </h2>
          <div className="font-sans text-[14px] md:text-[16px] leading-[1.6] md:leading-[1.7] text-txt-body space-y-3 md:space-y-4 mb-6 md:mb-8 relative z-10" data-id="element-219">
            <p data-id="element-220">Abrís los tomos. Aplicás el sistema en tus publicaciones.</p>
            <p className="font-sans font-bold text-lg md:text-xl text-txt-primary leading-snug py-2" data-id="element-221">
              Si en 15 días no es lo que esperabas:
              <br data-id="element-222" />
              devolución del 100%.
            </p>
            <p data-id="element-223">Sin formularios. Sin drama. Sin vueltas.</p>
          </div>
          <p className="font-sans font-bold uppercase tracking-[1.5px] text-[11px] text-txt-muted relative z-10" data-id="element-224">
            Tasa de devoluciones: menos del 2%.
          </p>
        </div>
      </FadeIn>
    </Section>;
};
export const FAQ = () => {
  const faqs = [{
    q: '¿Sirve si nunca vendí en Mercado Libre?',
    a: 'Sí. El sistema está diseñado para comerciantes que empiezan desde cero y para los que ya venden pero quieren mejorar. El Tomo 1 y el Bono de Setup Express te acompañan desde el primer paso hasta la primera venta.'
  }, {
    q: '¿Cómo recibo el material?',
    a: '100% digital en PDF. Inmediatamente después de confirmar el pago recibís un email con el link de descarga. Acceso en menos de 5 minutos desde cualquier dispositivo.'
  }, {
    q: '¿Sirve si ya tengo cuenta en MeLi pero vendo poco?',
    a: 'Es exactamente para eso. El sistema identifica qué está fallando (título, foto, precio, ficha técnica o categoría) y te da la corrección específica. La mayoría de los compradores que ya tienen cuenta ven resultados en la primera semana.'
  }, {
    q: '¿Necesito conocimientos de impuestos o contabilidad?',
    a: 'No. El Tomo 2 y el Volumen Potenciador de Impuestos están escritos en español común para personas sin formación contable. Todo explicado paso a paso con ejemplos del mercado argentino 2026.'
  }, {
    q: '¿Tiene garantía real?',
    a: 'Garantía de 15 días completa. Si en 15 días no es lo que esperabas, te devolvemos el 100% del dinero. Sin preguntas, sin formularios, sin demoras. Escribís a soportecentershop95@gmail.com y listo.'
  }, {
    q: '¿Los Potenciadores se pueden usar junto al MEGAPACK?',
    a: 'Son exactamente complementarios. El MEGAPACK te da el sistema base completo. Los Potenciadores te dan dominio avanzado en las 6 áreas que más impactan en la rentabilidad: SEO avanzado, publicidad, logística Full, impuestos, combos y automatización con IA.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <Section className="bg-bg-alt" data-id="element-225">
      <FadeIn className="max-w-3xl mx-auto" data-id="element-226">
        <h2 className="font-display font-extrabold uppercase text-[28px] md:text-[44px] leading-[1.1] text-txt-primary text-center mb-8 md:mb-10" data-id="element-227">
          ❓ LO QUE MÁS NOS <span className="text-brandGold" data-id="element-228">PREGUNTAN</span>
        </h2>
        <div className="space-y-3 md:space-y-4" data-id="element-229">
          {faqs.map((faq, i) => <div key={i} className={`bg-bg-card border border-line rounded-[16px] overflow-hidden transition-colors ${openIndex === i ? 'bg-bg-highlight' : ''}`} data-id="element-230">
              <button className="w-full px-5 py-4 md:px-6 md:py-5 text-left flex justify-between items-center gap-3" onClick={() => setOpenIndex(openIndex === i ? null : i)} data-id="element-231">
                <span className="font-sans font-bold text-[14px] md:text-[16px] text-txt-primary" data-id="element-232">
                  {faq.q}
                </span>
                {openIndex === i ? <ChevronUp className="text-brandGold shrink-0" size={20} data-id="element-233" /> : <ChevronDown className="text-txt-muted shrink-0" size={20} data-id="element-234" />}
              </button>
              {openIndex === i && <div className="px-5 pb-5 md:px-6 md:pb-5 font-sans text-[14px] md:text-[16px] leading-[1.6] md:leading-[1.7] text-txt-body border-t border-line pt-4" data-id="element-235">
                  {faq.a}
                </div>}
            </div>)}
        </div>
      </FadeIn>
    </Section>;
};
export const CostOfNotHaving = () => {
  const costs = [{
    sin: 'Publicaciones sin optimizar por semana',
    costo: 'Ventas perdidas que no vuelven'
  }, {
    sin: 'Retenciones de IIBB no recuperadas',
    costo: 'Plata tuya en manos del Estado'
  }, {
    sin: 'Margen calculado mal',
    costo: 'Perdés dinero en cada venta sin saberlo'
  }, {
    sin: 'Sin Full bien implementado',
    costo: 'Competidores que despachan más rápido te roban el ranking'
  }, {
    sin: 'Sin sistema de combos',
    costo: 'Ticket promedio 50% menor de lo posible'
  }, {
    sin: 'Operación 100% manual',
    costo: '8 horas diarias en lugar de 1 hora con automatización'
  }];
  return <Section className="bg-bg-base" data-id="element-236">
      <FadeIn className="max-w-3xl mx-auto" data-id="element-237">
        <h2 className="font-display font-extrabold uppercase md:text-[44px] text-center mb-8 md:mb-12 text-txt-primary text-[32px]" data-id="element-238">
          ⚖️ ¿CUÁNTO CUESTA <span className="text-brandGold" data-id="element-239">NO TENERLO?</span>
        </h2>

        <div className="bg-bg-card rounded-[16px] md:rounded-[20px] overflow-hidden border border-line mb-8 md:mb-10" data-id="element-240">
          <div className="grid grid-cols-2 bg-bg-highlight p-3 md:p-5" data-id="element-241">
            <div className="font-sans font-bold text-[12px] md:text-[16px] text-txt-muted" data-id="element-242">
              Sin el MEGAPACK
            </div>
            <div className="font-sans font-bold text-[12px] md:text-[16px] text-txt-primary pl-3 md:pl-5 border-l border-line" data-id="element-243">
              Costo real
            </div>
          </div>
          <div className="divide-y divide-line" data-id="element-244">
            {costs.map((row, i) => <div key={i} className="grid grid-cols-2 p-3 md:p-5 gap-3 md:gap-5 items-center" data-id="element-245">
                <div className="font-sans text-[12px] md:text-[15px] leading-[1.4] md:leading-[1.6] text-txt-muted pr-2" data-id="element-246">
                  {row.sin}
                </div>
                <div className="font-sans text-[12px] md:text-[15px] leading-[1.4] md:leading-[1.6] text-danger font-medium pl-3 md:pl-5 border-l border-line flex items-center gap-1.5" data-id="element-247">
                  <span data-id="element-248">→</span> {row.costo}
                </div>
              </div>)}
          </div>
        </div>

        <p className="font-sans font-bold text-[14px] md:text-xl text-center text-txt-primary" data-id="element-249">
          El próximo lunes puede ser diferente.
          <br data-id="element-250" />
          Podés seguir publicando como hasta ahora y esperar que algo cambie
          solo.
          <br data-id="element-251" />
          O podés entrar con el sistema completo.
          <br data-id="element-252" />
          Vos decidís.
        </p>
      </FadeIn>
    </Section>;
};
export const FinalCTA = () => {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  const [selected, setSelected] = useState<'plus' | 'basic'>('plus');
  return <Section className="bg-bg-alt border-t border-line pt-12 md:pt-16 pb-20 md:pb-24" data-id="element-253">
      <FadeIn className="max-w-[700px] mx-auto text-center" data-id="element-254">
        {/* Urgency intro copy */}
        <div className="mb-8 md:mb-10" data-id="element-255">
          <p className="font-display font-extrabold uppercase md:text-[40px] text-txt-primary text-[24px]" data-id="element-256">
            🚨 ÚLTIMA OPORTUNIDAD
          </p>
        </div>

        <div className="mb-10 md:mb-12" data-id="element-257">
          <h3 className="font-sans font-bold uppercase tracking-[1.5px] text-[11px] text-txt-primary mb-3 md:mb-4" data-id="element-258">
            ⏰ EL PRECIO CIERRA EN:
          </h3>
          <div className="inline-flex items-center gap-2 md:gap-3 bg-bg-card border-2 border-brandYellow px-5 py-3 md:px-6 md:py-4 rounded-[14px] shadow-[0_0_15px_rgba(255,230,0,0.15)]" data-id="element-259">
            <span className="font-display font-black text-[32px] md:text-[44px] text-brandYellow leading-none" data-id="element-260">
              {hours.toString().padStart(2, '0')}
            </span>
            <span className="font-display font-black text-[32px] md:text-[44px] text-txt-primary leading-none" data-id="element-261">
              :
            </span>
            <span className="font-display font-black text-[32px] md:text-[44px] text-brandYellow leading-none" data-id="element-262">
              {minutes.toString().padStart(2, '0')}
            </span>
            <span className="font-display font-black text-[32px] md:text-[44px] text-txt-primary leading-none" data-id="element-263">
              :
            </span>
            <span className="font-display font-black text-[32px] md:text-[44px] text-brandYellow leading-none" data-id="element-264">
              {seconds.toString().padStart(2, '0')}
            </span>
          </div>
          <p className="font-sans font-bold text-[11px] md:text-[13px] text-danger mt-3 uppercase tracking-[1.5px]" data-id="element-265">
            Después sube. No vuelve a este precio.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-4 md:gap-5 mb-10 md:mb-12" data-id="element-266">
          {/* Option 1 - Basic */}
          <div role="button" tabIndex={0} onClick={() => setSelected('basic')} onKeyDown={e => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            setSelected('basic');
          }
        }} className={`bg-bg-card rounded-[20px] p-5 md:p-8 text-left flex flex-col cursor-pointer transition-all duration-300 ${selected === 'basic' ? 'border-2 border-brandYellow shadow-[0_0_15px_rgba(255,230,0,0.1)]' : 'border border-line hover:border-brandGold'}`} data-id="element-267">
            <h4 className="font-sans font-bold text-base md:text-xl text-txt-primary leading-snug mb-2" data-id="element-268">
              📘 MEGAPACK COMERCIO PRODUCTIVO 2026
            </h4>
            <p className="font-sans text-[13px] md:text-[15px] leading-[1.5] text-txt-body mb-4 md:mb-6" data-id="element-269">
              6 Tomos + 6 Bonos · Sistema completo MeLi Argentina
            </p>
            <div className="mt-auto" data-id="element-270">
              <p className="font-sans font-normal text-[15px] md:text-[18px] line-through text-danger mb-1" data-id="element-271">
                $39.990
              </p>
              <p className={`font-display font-black text-[36px] md:text-[52px] leading-none mb-4 md:mb-6 transition-colors ${selected === 'basic' ? 'text-brandYellow' : 'text-txt-primary'}`} data-id="element-272">
                $22.990
              </p>
              <CTAButton href={PRODUCTS.basic.checkoutUrl} fullWidth variant={selected === 'basic' ? 'primary' : 'secondary'} trackingProduct="basic" data-id="element-273">
                QUIERO EL MEGAPACK
              </CTAButton>
            </div>
          </div>

          {/* Option 2 - Plus */}
          <div role="button" tabIndex={0} onClick={() => setSelected('plus')} onKeyDown={e => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            setSelected('plus');
          }
        }} className={`bg-bg-card rounded-[20px] p-5 md:p-8 text-left relative flex flex-col cursor-pointer transition-all duration-300 ${selected === 'plus' ? 'border-2 border-brandYellow shadow-[0_0_15px_rgba(255,230,0,0.1)]' : 'border border-line hover:border-brandGold'}`} data-id="element-274">
            <div className="absolute -top-3 left-1/2 transform -translate-x-1/2 bg-brandYellow text-brandNavy font-sans font-bold uppercase tracking-[1.5px] text-[10px] md:text-[11px] px-3 md:px-3.5 py-1 rounded-full whitespace-nowrap" data-id="element-275">
              ⭐ MÁS ELEGIDO
            </div>
            <h4 className="font-sans font-bold text-base md:text-xl text-txt-primary leading-snug mb-2" data-id="element-276">
              🏆 MEGAPACK + POTENCIADORES
            </h4>
            <p className="font-sans text-[13px] md:text-[15px] leading-[1.5] text-txt-body mb-4 md:mb-6" data-id="element-277">
              6 Tomos + 6 Bonos + 6 Potenciadores
            </p>
            <div className="mt-auto" data-id="element-278">
              <p className="font-sans font-normal text-[15px] md:text-[18px] line-through text-danger mb-1" data-id="element-279">
                $57.990
              </p>
              <p className={`font-display font-black text-[36px] md:text-[52px] leading-none mb-4 md:mb-6 transition-colors ${selected === 'plus' ? 'text-brandYellow' : 'text-txt-primary'}`} data-id="element-280">
                $34.990
              </p>
              <CTAButton href={PRODUCTS.plus.checkoutUrl} fullWidth variant={selected === 'plus' ? 'primary' : 'secondary'} trackingProduct="plus" data-id="element-281">
                QUIERO EL SISTEMA COMPLETO
              </CTAButton>
            </div>
          </div>
        </div>

        <div className="flex flex-wrap justify-center gap-4 md:gap-6 font-sans text-[12px] md:text-[13px] text-txt-muted" data-id="element-282">
          <span className="flex items-center gap-2" data-id="element-283">
            <Lock size={14} data-id="element-284" /> Pago 100% seguro
          </span>
          <span className="flex items-center gap-2" data-id="element-285">
            <Clock size={14} data-id="element-286" /> Acceso en 5 minutos
          </span>
          <span className="flex items-center gap-2" data-id="element-287">
            <ShieldCheck size={14} data-id="element-288" /> Garantía 15 días
          </span>
          <span className="flex items-center gap-2 w-full justify-center mt-2" data-id="element-289">
            <CreditCard size={14} data-id="element-290" /> Mercado Pago | Tarjeta | Transferencia
          </span>
        </div>
      </FadeIn>
    </Section>;
};
export const Footer = () => {
  return <footer className="bg-bg-base border-t border-line py-12 px-6" data-id="element-291">
      <div className="max-w-4xl mx-auto text-center space-y-6" data-id="element-292">
        <div data-id="element-293">
          <h2 className="font-display font-black text-xl text-txt-primary mb-1" data-id="element-294">
            🛒 MEGAPACK COMERCIO PRODUCTIVO 2026™
          </h2>
          <p className="font-sans font-bold text-sm text-brandGold" data-id="element-295">
            by CENTER SHOP DIGITAL
          </p>
        </div>

        <p className="font-sans text-[13px] text-txt-muted max-w-md mx-auto" data-id="element-296">
          El sistema de ventas número 1 para comerciantes argentinos que quieren
          dominar Mercado Libre en 2026. Porque tener un buen producto no
          alcanza si nadie lo encuentra.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-8 font-sans text-[13px] text-txt-muted pt-4" data-id="element-297">
          <a href="mailto:soportecentershop95@gmail.com" className="hover:text-txt-primary transition-colors" data-id="element-298">
            📧 soportecentershop95@gmail.com
          </a>
          <a href="#" className="hover:text-txt-primary transition-colors" data-id="element-299">
            📲 @centershop.digital
          </a>
        </div>

        <div className="pt-8 mt-8 border-t border-line space-y-3" data-id="element-300">
          <p className="font-sans text-[10px] md:text-xs text-txt-faint max-w-3xl mx-auto leading-relaxed" data-id="element-301">
            Este producto es un material educativo independiente y NO está
            afiliado, asociado, autorizado ni respaldado por Mercado Libre
            S.R.L. ni por ninguna de sus subsidiarias o afiliadas. "Mercado
            Libre", "Mercado Pago", "Mercado Envíos" y "Full" son marcas
            registradas de sus respectivos dueños y se mencionan únicamente con
            fines descriptivos y educativos. Los resultados pueden variar según
            el esfuerzo, la dedicación y las condiciones de cada negocio.
          </p>
          <p className="font-sans text-xs text-txt-faint mt-4" data-id="element-302">
            © 2026 Center Shop Digital. Todos los derechos reservados.
          </p>
          <p className="space-x-4 font-sans text-xs text-txt-faint" data-id="element-303">
            <a href="#" className="hover:text-txt-primary transition-colors" data-id="element-304">
              Términos y condiciones
            </a>
            <span data-id="element-305">·</span>
            <a href="#" className="hover:text-txt-primary transition-colors" data-id="element-306">
              Política de privacidad
            </a>
          </p>
        </div>
      </div>
    </footer>;
};